module.exports = __webpack_public_path__ + "static/media/three.af3cefb9.mp4";